module.exports = __webpack_public_path__ + "static/media/Icon_Graphics_Grey.4116dc98.svg";